/** Minimal key/value storage port (browser localStorage or in-memory). */
export interface StoragePort {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

/** Playback sink for mapped SFX triggers. */
export interface AudioPlayerPort {
  play(soundId: string): void;
}

/** Analytics sink — host wires PostHog or a no-op. */
export interface AnalyticsPort {
  emit(
    eventName: string,
    properties?: Record<string, unknown>,
    context?: Record<string, unknown>,
  ): void;
}

/** Structured logger sink — host wires `gameLogger` (DEV filters) or a no-op. */
export interface LoggerPort {
  debug(
    topic: string,
    message: string,
    context?: unknown,
    data?: Record<string, unknown>,
  ): void;
  info(
    topic: string,
    message: string,
    context?: unknown,
    data?: Record<string, unknown>,
  ): void;
  warn(
    topic: string,
    message: string,
    context?: unknown,
    data?: Record<string, unknown>,
  ): void;
}

export interface CompletedRunRecord {
  completedAt: string;
  clanName: string;
  turns: number;
  finalPopulation: number;
  finalFood: number;
  startTerrain: string;
  endTerrain: string;
  tilesExplored: number;
  mapTileCount: number;
}

/** Career chronicle sink. */
export interface ChroniclePort {
  appendWinRecord(record: CompletedRunRecord): boolean;
}

/** Resolve the default browser storage when present; otherwise null. */
export function defaultBrowserStorage(): StoragePort | null {
  try {
    if (typeof localStorage === "undefined") {
      return null;
    }
    return localStorage;
  } catch {
    return null;
  }
}
